 <template>
  <div class="home-page">
    <!-- Start cyber Main Menu Area -->
    <div
      id="sticky-header"
      class="cyber_nav_manu d-md-none d-lg-block d-sm-none d-none"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="navbar-content">
            <div class="logo">
              <a class="logo_img" href="#" title="ipipbright">
                <img :src="require('../assets/images/ipipbright.png')" style="height: 73px;" alt="" />
              </a>
            </div>
            <nav class="cyber_menu">
              <ul class="nav_scroll">
                <li><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>
                <li>
                  <router-link to="/" class="nav-link active">{{ t.services }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/dynamic">{{ t.serviceDynamic }}</router-link></li>
                  </ul>
                </li>
                <li><router-link to="/faq" class="nav-link">{{ t.tutorial }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/faq">{{ t.faq }}</router-link></li>
                  </ul>
                </li>
                <li>
                  <a href="#blog" >{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                  <ul class="sub-menu">
                    <li><a href="javascript:void(0);" @click="setLanguage('en')">English</a></li>
                    <li><a href="javascript:void(0);" @click="setLanguage('zh')">简体中文</a></li>
                  </ul>
                </li>
              </ul>
              <div class="auth-buttons">
                <router-link to="/login" class="auth-btn login-btn">{{ t.login }}</router-link>
                <router-link to="/register" class="auth-btn register-btn">{{ t.register }}</router-link>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-menu-area d-sm-block d-md-block d-lg-none">
      <div class="mobile-menu-container">
        <div class="mobile-menu-header">
          <div class="mobile-menu-logo">
            <a href="/" title="ipipbright">
              <img :src="require('../assets/images/ipipbright.png')" style="height: 40px; margin: 10px 0 0 15px;" alt="ipipbright" />
            </a>
          </div>
          <a href="javascript:void(0);" class="mobile-menu-toggle" @click="toggleMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>
        <div class="mobile-menu-body" v-show="isMobileMenuOpen">
          <ul class="mobile-menu-list">
            <li class="mobile-menu-item"><a href="javascript:void(0);" class="mobile-menu-link" @click="handleMobileNavClick('/')">{{ t.home }}</a></li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#home" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Package')">{{ t.services }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Package')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Package'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/dynamic')">{{ t.serviceDynamic }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="/faq" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Tutorial')">{{ t.tutorial }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Tutorial')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Tutorial'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/faq')">{{ t.faq }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#language" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'English')">{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'English')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'English'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('en')">English</a></li>
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('zh')">简体中文</a></li>
              </ul>
            </li>
          </ul>
          <div class="mobile-auth-buttons">
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-login-btn" @click="handleMobileNavClick('/login')">{{ t.login }}</a>
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-register-btn" @click="handleMobileNavClick('/register')">{{ t.register }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- End cyber Main Menu Area -->

    <!-- Start cyber Slider Area -->
    <div class="slider_area" id="home">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="single_slider">
              <div class="slider_banner_shap">
                <div class="slider_banner_shap3">
                  <img :src="require('../assets/images/sl-shape3.png')" alt="" />
                </div>
              </div>
              <div class="slider_content">
                <div class="slider_text">
                  <div class="slider_text_inner">
                    <h1>{{ t.bannerTitle1 }}</h1>
                    <h1>{{ t.bannerTitle2 }}</h1>
                    <p>
                      {{ t.bannerDesc }}
                    </p>
                  </div>
                  <div class="slider_button d-flex">
                    <div class="slider_button_inner">
                      <a href="/login">{{ t.bannerButton }}</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="single_slider_rot">
                <div class="single_slider_rot_inner rotateme">
                  <img :src="require('../assets/images/sdt.png')" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Cyber Slider Area -->

    <!-- Start Cyber Feature Area -->
    <div class="feature_area">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-sm-6">
            <div class="single_feature mb-4">
              <div class="single_feature_content">
                <div class="single_feature_icon pb-3">
                  <div class="icon">
                    <i class="flaticon-server"></i>
                  </div>
                </div>
                <div class="single_feature_content_inner">
                  <h2>{{ t.feature1Title }}</h2>
                  <p>{{ t.feature1Desc }}</p>
                </div>
              </div>
              <div class="shape-one"></div>
              <div class="shape-two"></div>
              <div class="shape-three"></div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6">
            <div class="single_feature mb-4">
              <div class="single_feature_content">
                <div class="single_feature_icon pb-3">
                  <div class="icon">
                    <i class="flaticon-rocket"></i>
                  </div>
                </div>
                <div class="single_feature_content_inner">
                  <h2>{{ t.feature2Title }}</h2>
                  <p>{{ t.feature2Desc }}</p>
                </div>
              </div>
              <div class="shape-one"></div>
              <div class="shape-two"></div>
              <div class="shape-three"></div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6">
            <div class="single_feature mb-4">
              <div class="single_feature_content">
                <div class="single_feature_icon pb-3">
                  <div class="icon">
                    <i class="flaticon-shield"></i>
                  </div>
                </div>
                <div class="single_feature_content_inner">
                  <h2>{{ t.feature3Title }}</h2>
                  <p>{{ t.feature3Desc }}</p>
                </div>
              </div>
              <div class="shape-one"></div>
              <div class="shape-two"></div>
              <div class="shape-three"></div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6">
            <div class="single_feature mb-4">
              <div class="single_feature_content">
                <div class="single_feature_icon pb-3">
                  <div class="icon">
                    <i class="flaticon-data"></i>
                  </div>
                </div>
                <div class="single_feature_content_inner">
                  <h2>{{ t.feature4Title }}</h2>
                  <p>{{ t.feature4Desc }}</p>
                </div>
              </div>
              <div class="shape-one"></div>
              <div class="shape-two"></div>
              <div class="shape-three"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Cyber Feature Area -->

    <!-- End Cyber Service Area -->
    <div class="service_area">
      <div class="container">
        <div class="row">
          <!-- Start Section Tile -->
          <div class="col-md-12">
            <div class="section_title left">
              <!-- Sub Title -->
              <div class="section_title_inner">
                <h2>{{ t.serviceAreaTitle }}</h2>
              </div>
              <div class="em_bar">
                <div class="em_bar_bg"></div>
              </div>
              <div class="section_title_text">
                <p>
                  {{ t.serviceAreaDesc }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-sm-6">
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-rotate-right"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service1 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa-solid fa-globe"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service2 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-shield"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service3 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa-solid fa-bolt"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service4 }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6">
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-unlock"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service5 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-users"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service6 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-clock"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service7 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-cogs"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service8 }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="service_single_thumb right">
              <div class="single_service_inner_thumb">
                <img :src="require('../assets/images/service2.png')" alt="" />
              </div>
              <div class="single_service_brg">
                <div class="single_service_brg_thumb rotateme">
                  <img :src="require('../assets/images/service-rot.png')" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Cyber Service Area -->

    <!-- End Cyber Service Area -->
    <div class="service_area style2">
      <div class="container">
        <div class="row">
          <!-- Start Section Tile -->
          <div class="col-md-12">
            <div class="section_title left middle">
              <!-- Sub Title -->
              <div class="section_title_inner">
                <h2>{{ t.serviceArea2Title }}</h2>
              </div>
              <div class="em_bar">
                <div class="em_bar_bg"></div>
              </div>
              <div class="section_title_text">
                <p>
                  {{ t.serviceArea2Desc }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="service_single_thumb left">
              <div class="single_service_inner_thumb">
                <img :src="require('../assets/images/service1.png')" alt="" />
              </div>
              <div class="single_service_brg">
                <div class="single_service_brg_thumb rotateme">
                  <img :src="require('../assets/images/service-rot.png')" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6">
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-user-secret"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service9 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-sitemap"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service10 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-mobile"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service11 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-list"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service12 }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6">
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-check-circle"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service13 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-map-marker"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service14 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-calendar"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service15 }}</h4>
                </div>
              </div>
            </div>
            <div class="single_service">
              <div class="single_service_inner">
                <div class="single_service_icon">
                  <i class="fa fa-chart-line"></i>
                </div>
                <div class="single_service_content">
                  <h4>{{ t.service16 }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Cyber Service Area -->

    <!-- Start Country IP Stats Area -->
    <div class="country_ip_area">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="section_title center">
              <div class="section_title_inner">
                <h2>{{ t.countryIpTitle }}</h2>
              </div>
              <div class="em_bar">
                <div class="em_bar_bg"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row country_grid">
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/us.png" alt="United States">
              </div>
              <div class="country_info">
                <h4 class="country_name">United States</h4>
                <p class="ip_count">1,341,385</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/de.png" alt="Germany">
              </div>
              <div class="country_info">
                <h4 class="country_name">Germany</h4>
                <p class="ip_count">1,103,502</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/gb.png" alt="United Kingdom">
              </div>
              <div class="country_info">
                <h4 class="country_name">United Kingdom</h4>
                <p class="ip_count">199,240</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/fr.png" alt="France">
              </div>
              <div class="country_info">
                <h4 class="country_name">France</h4>
                <p class="ip_count">198,502</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/ca.png" alt="Canada">
              </div>
              <div class="country_info">
                <h4 class="country_name">Canada</h4>
                <p class="ip_count">187,952</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/br.png" alt="Brazil">
              </div>
              <div class="country_info">
                <h4 class="country_name">Brazil</h4>
                <p class="ip_count">1,213,841</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/es.png" alt="Spain">
              </div>
              <div class="country_info">
                <h4 class="country_name">Spain</h4>
                <p class="ip_count">1,183,945</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/it.png" alt="Italy">
              </div>
              <div class="country_info">
                <h4 class="country_name">Italy</h4>
                <p class="ip_count">192,507</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/vn.png" alt="Vietnam">
              </div>
              <div class="country_info">
                <h4 class="country_name">Vietnam</h4>
                <p class="ip_count">1,108,403</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/ph.png" alt="Philippines">
              </div>
              <div class="country_info">
                <h4 class="country_name">Philippines</h4>
                <p class="ip_count">1,128,407</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/pl.png" alt="Poland">
              </div>
              <div class="country_info">
                <h4 class="country_name">Poland</h4>
                <p class="ip_count">188,205</p>
              </div>
            </div>
          </div>
          <!-- Country IP Card -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <div class="country_ip_card">
              <div class="country_flag">
                <img src="https://flagcdn.com/48x36/jp.png" alt="Japan">
              </div>
              <div class="country_info">
                <h4 class="country_name">Japan</h4>
                <p class="ip_count">1,114,604</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Country IP Stats Area -->

    <!-- Start Cyber Feature Box Area -->
    <div class="feature_box_area">
      <div class="container">
        <div class="row">
          <!-- Start Section Tile -->
          <div class="col-md-12">
            <div class="section_title center">
              <!-- Sub Title -->
              <div class="section_title_inner">
                <h2>{{ t.featureBoxTitle }}</h2>
              </div>
              <div class="em_bar">
                <div class="em_bar_bg"></div>
              </div>
              <div class="section_title_text">
                <p>
                  {{ t.featureBoxSubtitle }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-sm-6 col-xs-12">
            <div class="single_feature_box">
              <div class="single_feature_box_icon">
                <i class="fa fa-globe"></i>
              </div>
              <div class="single_feature_box_content">
                <h2>{{ t.featureBox1Title }}</h2>
              </div>
              <div class="single_feature_box_content_text">
                <p>
                  {{ t.featureBox1Desc }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 col-xs-12">
            <div class="single_feature_box">
              <div class="single_feature_box_icon">
                <i class="fa fa-bolt"></i>
              </div>
              <div class="single_feature_box_content">
                <h2>{{ t.featureBox2Title }}</h2>
              </div>
              <div class="single_feature_box_content_text">
                <p>
                  {{ t.featureBox2Desc }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 col-xs-12">
            <div class="single_feature_box">
              <div class="single_feature_box_icon">
                <i class="fa-solid fa-shield-halved"></i>
              </div>
              <div class="single_feature_box_content">
                <h2>{{ t.featureBox3Title }}</h2>
              </div>
              <div class="single_feature_box_content_text">
                <p>
                  {{ t.featureBox3Desc }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 col-xs-12">
            <div class="single_feature_box">
              <div class="single_feature_box_icon">
                <i class="fa-solid fa-sync-alt"></i>
              </div>
              <div class="single_feature_box_content">
                <h2>{{ t.featureBox4Title }}</h2>
              </div>
              <div class="single_feature_box_content_text">
                <p>
                  {{ t.featureBox4Desc }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 col-xs-12">
            <div class="single_feature_box">
              <div class="single_feature_box_icon">
                <i class="fa-solid fa-server"></i>
              </div>
              <div class="single_feature_box_content">
                <h2>{{ t.featureBox5Title }}</h2>
              </div>
              <div class="single_feature_box_content_text">
                <p>
                  {{ t.featureBox5Desc }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 col-xs-12">
            <div class="single_feature_box">
              <div class="single_feature_box_icon">
                <i class="fa-solid fa-headset"></i>
              </div>
              <div class="single_feature_box_content">
                <h2>{{ t.featureBox6Title }}</h2>
              </div>
              <div class="single_feature_box_content_text">
                <p>
                  {{ t.featureBox6Desc }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Cyber Feature Box Area -->

    <!-- Start cyber Pricing Area -->
    <div class="pricing_area" id="pricing">
      <div class="container">
        <div class="row">
          <!-- Start Section Tile -->
          <div class="col-md-12">
            <div class="section_title center">
              <!-- Sub Title -->
              <div class="section_title_inner">
                <h2>{{ t.pricingSectionTitle }}</h2>
              </div>
              <div class="em_bar">
                <div class="em_bar_bg"></div>
              </div>
              <div class="section_title_text">
                <p>
                  {{ t.pricingSectionSubtitle }}
                </p>
              </div>
              <div class="pricing_shape_thumb">
                <div class="pricing_shape_thumb_inner rotateme">
                  <img :src="require('../assets/images/shape4.png')" alt="" />
                </div>
                <div class="pricing_shape_thumb_inner2">
                  <img :src="require('../assets/images/shape5.png')" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <!-- Single Pricing -->
            <div class="single_pricing">
              <div class="single_pricing_content">
                <div class="single_pricing_content_inner">
                  <div class="pricing_head">
                    <div class="pricing_title">
                      <h3>{{ t.beginnerPlan }}</h3>
                    </div>
                    <div class="pricing_tk">
                      <h2><span>{{ t.plan1GB }}</span></h2>
                      <h2>$3 <span>{{ t.perMonth }}</span></h2>
                    </div>
                  </div>

                  <div class="pricing_body">
                    <div class="featur">
                      <ul>
                        <li>{{ t.unmeteredData }}</li>
                        <li>{{ t.unlimitedThreads }}</li>
                        <li>{{ t.chooseCountries }}</li>
                        <li>{{ t.staticIPUpdates }}</li>
                        <li>{{ t.datacenterIP }}</li>
                        <li>{{ t.staticResidentialIP }}</li>
                        <li>{{ t.rotatingResidentialIP }}</li>
                        <li>{{ t.mobileIP }}</li>
                        <li>{{ t.tier1ISPs }}</li>
                        <li>{{ t.connectionLimit }}</li>
                        <li>{{ t.socks5HTTPProxy }}</li>
                        <li>{{ t.countryIPUpdater }}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="pricing_button">
                    <div class="order_now">
                      <a href="/login">{{ t.getNow }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <!-- Single Pricing -->
            <div class="single_pricing">
              <div class="single_pricing_content">
                <div class="single_pricing_content_inner active">
                  <div class="pricing_head">
                    <div class="pricing_title">
                      <h3>BEGINNER</h3>
                    </div>
                    <div class="pricing_tk">
                      <h2><span>{{ t.plan10GB }}</span></h2>
                      <h2>$30 <span>{{ t.perMonth }}</span></h2>
                    </div>
                  </div>

                  <div class="pricing_body">
                    <div class="featur">
                      <ul>
                        <li>{{ t.unmeteredData }}</li>
                        <li>{{ t.unlimitedThreads }}</li>
                        <li>{{ t.chooseCountries }}</li>
                        <li>{{ t.staticIPUpdates }}</li>
                        <li>{{ t.datacenterIP }}</li>
                        <li>{{ t.staticResidentialIP }}</li>
                        <li>{{ t.rotatingResidentialIP }}</li>
                        <li>{{ t.mobileIP }}</li>
                        <li>{{ t.tier1ISPs }}</li>
                        <li>{{ t.connectionLimit }}</li>
                        <li>{{ t.socks5HTTPProxy }}</li>
                        <li>{{ t.countryIPUpdater }}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="pricing_button">
                    <div class="order_now">
                      <a href="/login">{{ t.getNow }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <!-- Single Pricing -->
            <div class="single_pricing">
              <div class="single_pricing_content">
                <div class="single_pricing_content_inner">
                  <div class="pricing_head">
                    <div class="pricing_title">
                      <h3>BEGINNER</h3>
                    </div>
                    <div class="pricing_tk">
                      <h2><span>{{ t.plan50GB }}</span></h2>
                      <h2>$150 <span>{{ t.perMonth }}</span></h2>
                    </div>
                  </div>

                  <div class="pricing_body">
                    <div class="featur">
                      <ul>
                        <li>{{ t.unmeteredData }}</li>
                        <li>{{ t.unlimitedThreads }}</li>
                        <li>{{ t.chooseCountries }}</li>
                        <li>{{ t.staticIPUpdates }}</li>
                        <li>{{ t.datacenterIP }}</li>
                        <li>{{ t.staticResidentialIP }}</li>
                        <li>{{ t.rotatingResidentialIP }}</li>
                        <li>{{ t.mobileIP }}</li>
                        <li>{{ t.tier1ISPs }}</li>
                        <li>{{ t.connectionLimit }}</li>
                        <li>{{ t.socks5HTTPProxy }}</li>
                        <li>{{ t.countryIPUpdater }}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="pricing_button">
                    <div class="order_now">
                      <a href="/login">{{ t.getNow }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <!-- Single Pricing -->
            <div class="single_pricing">
              <div class="single_pricing_content">
                <div class="single_pricing_content_inner">
                  <div class="pricing_head">
                    <div class="pricing_title">
                      <h3>BEGINNER</h3>
                    </div>
                    <div class="pricing_tk">
                      <h2><span>{{ t.plan100GB }}</span></h2>
                      <h2>$300 <span>{{ t.perMonth }}</span></h2>
                    </div>
                  </div>

                  <div class="pricing_body">
                    <div class="featur">
                      <ul>
                        <li>{{ t.unmeteredData }}</li>
                        <li>{{ t.unlimitedThreads }}</li>
                        <li>{{ t.chooseCountries }}</li>
                        <li>{{ t.staticIPUpdates }}</li>
                        <li>{{ t.datacenterIP }}</li>
                        <li>{{ t.staticResidentialIP }}</li>
                        <li>{{ t.rotatingResidentialIP }}</li>
                        <li>{{ t.mobileIP }}</li>
                        <li>{{ t.tier1ISPs }}</li>
                        <li>{{ t.connectionLimit }}</li>
                        <li>{{ t.socks5HTTPProxy }}</li>
                        <li>{{ t.countryIPUpdater }}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="pricing_button">
                    <div class="order_now">
                      <a href="/login">{{ t.getNow }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End cyber Pricing Area -->

    <!-- Footer Area -->
    <div class="footer-middle" id="footer">
      <div class="container">
        <div class="row">
          <!--footer widget 1 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div class="widget widgets_company_info">
              <h2 class="widget-title">{{ t.footerTitle }}</h2>
              <div class="company_info_desc">
                <p>
                  {{ t.footerDesc }}
                </p>
              </div>
              <div class="social_media">
                <h3>{{ t.followUs }}</h3>
                <a href="javascript:void(0);"><i class="fa-brands fa-facebook-f"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-linkedin-in"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-telegram"></i></a>
              </div>
            </div>
          </div>

          <!--footer widget 2 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-8" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.quickLinks }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/"> {{ t.home }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/privacy"> {{ t.privacy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/service-policy"> {{ t.servicePolicy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/faq"> {{ t.faq }} </a>
                    </h4>
                  </div>
                </div>
                <!-- <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="#"> 关于我们 </a>
                    </h4>
                  </div>
                </div> -->
                <!-- <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="#"> 联系我们 </a>
                    </h4>
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <!--footer widget 3 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-7" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.productsServices }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/dynamic"> {{ t.serviceDynamic }} </a>
                    </h4>
                  </div>
                </div>
                <!-- <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="#"> 静态IP代理 </a>
                    </h4>
                  </div>
                </div> -->
                <!-- <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="#"> 住宅IP代理 </a>
                    </h4>
                  </div>
                </div> -->
                <!-- <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="#"> 数据中心IP </a>
                    </h4>
                  </div>
                </div> -->
                <!-- <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="#"> 移动IP代理 </a>
                    </h4>
                  </div>
                </div> -->
                <!-- <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="#"> SOCKS5代理 </a>
                    </h4>
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <!--footer widget 4 -->
          <div class="col-lg-3 col-md-6 col-xs-12 last">
            <div class="widget widget_get_quote">
              <h2 class="widget-title">{{ t.contactUs }}</h2>
              <div class="widget_get_quote_content">
                <div class="widget_quote_text">
                  <div class="footer_quote_text_decripsition">
                    <div class="footer_quote_decripsition_inner">
                      <p>
                        {{ t.footerContactDesc }}
                      </p>
                    </div>
                  </div>
                  <!-- <div class="footer_s_inner">
                    <div class="footer-sociala-icon">
                      <i class="fa fa-map-marker"></i>
                    </div>
                    <div class="footer-sociala-info">
                      <p>北京市朝阳区建国路88号</p>
                    </div>
                  </div>
                  <div class="footer_s_inner">
                    <div class="footer-sociala-icon">
                      <i class="fa fa-phone"></i>
                    </div>
                    <div class="footer-sociala-info">
                      <p>+86 138 0013 8000</p>
                    </div>
                  </div>
                  <div class="footer_s_inner">
                    <div class="footer-sociala-icon">
                      <i class="fa fa-envelope"></i>
                    </div>
                    <div class="footer-sociala-info">
                      <p>support@ipipbright.com</p>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Area -->
    
    <!-- Footer Bottom Area -->
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="footer-bottom-content">
              <p>Ipipbright. © 2024 All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Bottom Area -->
    
    <!-- Simple go to top button -->
    <div 
      id="simple-go-top" 
      @click="scrollToTop"
      style="
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 55px;
        height: 55px;
        background: linear-gradient(135deg, #1581c6, #1581c6);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 9999999;
        font-size: 26px;
        font-weight: bold;
        box-shadow: 0 8px 25px rgba(21, 129, 198, 0.6);
        transition: all 0.3s ease;
        opacity: 0;
        visibility: hidden;
        border: none;
      "
    >
      ↑
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// import { getField, updateField } from 'vuex-map-fields'
import '../assets/css/boxicons.min.css'
import '../assets/css/bootstrap.min.css'
import '../assets/css/owl.carousel.min.css'
import '../assets/css/owl.transitions.css'
import '../assets/css/animate.css'
import '../assets/fonts/font-awesome/css/font-awesome.min.css'
import '../assets/fonts/flaticon/font/flaticon.css'
import '../assets/css/theme-default.css'
import '../assets/css/meanmenu.min.css'
import '../assets/css/responsive.css'
import '../assets/css/widget.css'
import '../assets/css/style.css'
import '../assets/venobox/venobox.css'

export default {
  name: 'HomeNew',
  inject: ['changeLanguage', 'languageState'],
  data() {
    return {
      isNavCollapsed: true,
      isSticky: false,
      isMobileMenuOpen: false,
      activeDropdown: '',
      language: 'en',
      // 页面文本国际化配置
      i18n: {
        en: {
            home: 'Home',
            services: 'Package',
            serviceDynamic: 'Dynamic residence',
            serviceStatic: 'Static residence',
            blog: 'Tutorial Center',
            tutorial: 'Tutorial',
            faq: 'FAQs',
            signIn: 'Sign In',
            signUp: 'Sign Up',
            login: 'Login',
            register: 'Register',
            learnMore: 'Buy Now',
            dynamicDesc: 'High-quality dynamic residential IP proxy services to help you easily access global network resources while protecting your privacy and security.',
            featuresTitle: 'Key Features',
            featuresSubtitle: 'Discover the powerful features of our dynamic residential proxy services',
            globalCoverage: 'Global IP Coverage',
            globalCoverageDesc: 'Access to millions of residential IPs from over 170+ countries and regions',
            autoRotation: 'Automatic IP Rotation',
            autoRotationDesc: 'Automatically rotate IPs at intervals or on each request',
            highTrust: 'High Trust IPs',
            highTrustDesc: 'Avoid detection with IPs that have high trust scores',
            highSpeed: 'High Speed & Low Latency',
            highSpeedDesc: 'Fast and stable connections for optimal performance',
            multiProtocol: 'Multi-Protocol Support',
            multiProtocolDesc: 'Supports HTTP, HTTPS, and SOCKS5 protocols',
            technicalSupport: '24/7 Technical Support',
            technicalSupportDesc: 'Professional support team available around the clock',
            benefitsTitle: 'Why Choose Our Dynamic Residential Proxies?',
            benefit1: 'Access geo-restricted content',
            benefit2: 'Bypass IP bans and restrictions',
            benefit3: 'Protect your online privacy',
            benefit4: 'Ideal for web scraping and data mining',
            benefit5: 'Suitable for ad verification and market research',
            pricingTitle: 'Flexible Pricing Plans',
            pricingSubtitle: 'Choose the perfect plan for your needs',
            basicPlan: 'BASIC',
            standardPlan: 'STANDARD',
            advancedPlan: 'ADVANCED',
            enterprisePlan: 'ENTERPRISE',
            premiumIPs: 'Premium Residential IPs',
            rotatingIPs: 'Rotating IPs',
            rotatingSticky: 'Rotating & Sticky IPs',
            highTrustIPs: 'High Trust IPs',
            unlimitedThreads: 'Unlimited Threads',
            getNow: 'Get Now',
            // Home page specific content
            bannerTitle1: 'Use cases - we\'ve got you covered',
            bannerTitle2: 'Reliable data collection tools for all your client tasks',
            bannerDesc: 'Power Your Web Scraping & Data Gathering With Our Residential,Mobile And Datacenter Proxies. Gain access to proxies in over 170+countries and 50,000,000+ worldwide clean IP Addresses to access any content at scale.',
            bannerButton: 'Buy Now',
            // Feature section
            feature1Title: 'Global IP Coverage',
            feature1Desc: 'Access IPs from over 180 countries worldwide with our extensive proxy network.',
            feature2Title: 'High-Speed Connection',
            feature2Desc: 'Blazing fast proxy servers with 99.9% uptime ensuring uninterrupted service.',
            feature3Title: 'Privacy Protection',
            feature3Desc: 'Complete anonymity with rotating IPs and military-grade encryption.',
            feature4Title: 'Unlimited Bandwidth',
            feature4Desc: 'No limits on data usage with flexible plans for any scale requirement.',
            // Service area 1
            serviceAreaTitle: 'IP Proxy Services',
            serviceAreaDesc: 'High-quality dynamic IP proxy solutions for various business needs, providing secure and reliable connection services worldwide.',
            service1: 'Rotating Proxies',
            service2: 'Global Coverage',
            service3: 'Secure Connection',
            service4: 'High Speed',
            service5: 'Unlimited Bandwidth',
            service6: 'Business Solutions',
            service7: '24/7 Support',
            service8: 'Easy Integration',
            // Service area 2
            serviceArea2Title: 'Proxy Features',
            serviceArea2Desc: 'Advanced proxy features designed to meet the needs of modern web scraping, data collection, and online privacy protection.',
            service9: 'Anonymous Browsing',
            service10: 'HTTP/HTTPS Support',
            service11: 'Mobile Proxies',
            service12: 'API Access',
            service13: 'IP Authentication',
            service14: 'City Targeting',
            service15: 'Flexible Plans',
            service16: 'Real-time Statistics',
            // Country IP stats
            countryIpTitle: 'YOUR IDEAL PROXY SOLUTION FOR ALL NEEDS',
            // Feature box area
            featureBoxTitle: 'Core Advantages of IP Proxy',
            featureBoxSubtitle: 'Providing global dynamic IP proxy services, supporting multiple protocols, stable and reliable, meeting various business needs.',
            featureBox1Title: 'Global IP Coverage',
            featureBox1Desc: 'Covering 200+ countries and regions worldwide, with over 100 million+ dynamic IP resources, meeting business needs in different regions.',
            featureBox2Title: 'High Speed and Stability',
            featureBox2Desc: 'Using high-quality network lines, low latency, fast speed, stable and reliable, ensuring smooth business operation.',
            featureBox3Title: 'Security and Anonymity',
            featureBox3Desc: 'Strictly protecting user privacy, IP automatically switches, effectively hiding real IP address, preventing being tracked.',
            featureBox4Title: 'Dynamic Switching',
            featureBox4Desc: 'Support automatic IP switching by time and times, or manual switching, flexibly adapting to different business scenarios.',
            featureBox5Title: 'Multi-Protocol Support',
            featureBox5Desc: 'Supporting multiple protocols such as HTTP, HTTPS, SOCKS5, meeting different application scenario needs.',
            featureBox6Title: '24/7 Technical Support',
            featureBox6Desc: 'Professional technical team serves you around the clock, timely solving various problems, ensuring smooth business operation.',
            // Pricing area
            pricingSectionTitle: 'Pricing Plans',
            pricingSectionSubtitle: 'Choose the IP proxy plan that suits your needs, flexible traffic options, meeting different business scenarios',
            beginnerPlan: 'BEGINNER',
            plan1GB: '1GB',
            plan10GB: '10GB',
            plan50GB: '50GB',
            plan100GB: '100GB',
            perMonth: '/month',
            // Pricing features
            unmeteredData: 'Unmetered data usage',
            chooseCountries: 'Choose up to 5 countries',
            staticIPUpdates: '20 Static IP updates per month',
            datacenterIP: 'Datacenter IP',
            staticResidentialIP: 'Static Residential IP',
            rotatingResidentialIP: 'Rotating Residential IP',
            mobileIP: 'Mobile IP',
            tier1ISPs: 'Tier 1 ISP\'s',
            connectionLimit: '5 Connection limit',
            socks5HTTPProxy: 'SOCKS5 & HTTP Proxy',
            countryIPUpdater: 'Country/Region IP Updater',
            // Footer area
            footerTitle: 'IPIPBright',
            footerDesc: 'Providing global dynamic IP proxy services, covering 200+ countries and regions, with over 100 million+ IP resources, stable and reliable, meeting various business needs.',
            followUs: 'Follow Us',
            quickLinks: 'Quick Links',
            productsServices: 'Product Services',
            contactUs: 'Contact Us',
            privacy: 'Privacy Policy',
            servicePolicy: 'Service Policy',
            footerContactDesc: '24/7 technical support, ready to answer your questions, providing professional IP proxy solutions.'
          },
          zh: {
            home: '首页',
            services: '动态套餐',
            serviceDynamic: '动态住宅',
            serviceStatic: '静态住宅',
            blog: '教程中心',
            tutorial: '教程中心',
            faq: '常见问题',
            signIn: '登录',
            signUp: '注册',
            login: '登录',
            register: '注册',
            learnMore: '立即购买',
            dynamicDesc: '高质量的动态住宅IP代理服务，帮助您轻松访问全球网络资源，同时保护您的隐私和安全。',
            featuresTitle: '核心功能',
            featuresSubtitle: '探索我们动态住宅代理服务的强大功能',
            globalCoverage: '全球IP覆盖',
            globalCoverageDesc: '访问来自170多个国家和地区的数百万住宅IP',
            autoRotation: '自动IP轮换',
            autoRotationDesc: '按时间间隔或每次请求自动轮换IP',
            highTrust: '高信任IP',
            highTrustDesc: '使用具有高信任评分的IP避免检测',
            highSpeed: '高速低延迟',
            highSpeedDesc: '快速稳定的连接，提供最佳性能',
            multiProtocol: '多协议支持',
            multiProtocolDesc: '支持HTTP、HTTPS和SOCKS5协议',
            technicalSupport: '24/7技术支持',
            technicalSupportDesc: '专业支持团队全天候为您服务',
            benefitsTitle: '为什么选择我们的动态住宅代理？',
            benefit1: '访问地理限制内容',
            benefit2: '绕过IP禁令和限制',
            benefit3: '保护您的在线隐私',
            benefit4: '理想的网页抓取和数据挖掘工具',
            benefit5: '适合广告验证和市场研究',
            pricingTitle: '灵活的定价计划',
            pricingSubtitle: '选择适合您需求的完美计划',
            basicPlan: '基础版',
            standardPlan: '标准版',
            advancedPlan: '高级版',
            enterprisePlan: '企业版',
            premiumIPs: '优质住宅IP',
            rotatingIPs: '动态IP',
            rotatingSticky: '动态&静态IP',
            highTrustIPs: '高信任IP',
            unlimitedThreads: '无限线程',
            getNow: '立即购买',
            // Home page specific content
            bannerTitle1: '用例 - 我们为您提供全面支持',
            bannerTitle2: '可靠的数据收集工具，满足您所有的客户任务',
            bannerDesc: '使用我们的住宅、移动和数据中心代理为您的网页抓取和数据收集提供动力。访问来自170多个国家的代理和50,000,000+全球干净IP地址，大规模访问任何内容。',
            bannerButton: '立即购买',
            // Feature section
            feature1Title: '全球IP覆盖',
            feature1Desc: '通过我们广泛的代理网络访问来自全球180多个国家的IP。',
            feature2Title: '高速连接',
            feature2Desc: '超快的代理服务器，99.9%的正常运行时间确保服务不中断。',
            feature3Title: '隐私保护',
            feature3Desc: '通过轮换IP和军用级加密实现完全匿名。',
            feature4Title: '无限带宽',
            feature4Desc: '无数据使用限制，提供适合各种规模需求的灵活计划。',
            // Service area 1
            serviceAreaTitle: 'IP代理服务',
            serviceAreaDesc: '高品质的动态IP代理解决方案，满足各种业务需求，提供全球安全可靠的连接服务。',
            service1: '动态IP代理',
            service2: '全球覆盖',
            service3: '安全连接',
            service4: '高速代理',
            service5: '无限带宽',
            service6: '企业解决方案',
            service7: '24/7支持',
            service8: '易于集成',
            // Service area 2
            serviceArea2Title: '代理功能',
            serviceArea2Desc: '先进的代理功能，专为满足现代网页抓取、数据收集和在线隐私保护的需求而设计。',
            service9: '匿名浏览',
            service10: 'HTTP/HTTPS支持',
            service11: '移动代理',
            service12: 'API访问',
            service13: 'IP认证',
            service14: '城市定位',
            service15: '灵活计划',
            service16: '实时统计',
            // Country IP stats
            countryIpTitle: '满足您所有需求的理想代理解决方案',
            // Feature box area
            featureBoxTitle: 'IP代理核心优势',
            featureBoxSubtitle: '提供全球动态IP代理服务，支持多种协议，稳定可靠，满足各类业务需求。',
            featureBox1Title: '全球IP覆盖',
            featureBox1Desc: '覆盖全球200+国家和地区，拥有超过1亿+动态IP资源，满足不同地区业务需求。',
            featureBox2Title: '高速稳定',
            featureBox2Desc: '采用优质网络线路，延迟低，速度快，稳定可靠，确保业务流畅运行。',
            featureBox3Title: '安全匿名',
            featureBox3Desc: '严格保护用户隐私，IP自动切换，有效隐藏真实IP地址，防止被追踪。',
            featureBox4Title: '动态切换',
            featureBox4Desc: '支持按时间、次数自动切换IP，也可手动切换，灵活适应不同业务场景。',
            featureBox5Title: '多协议支持',
            featureBox5Desc: '支持HTTP、HTTPS、SOCKS5等多种协议，满足不同应用场景需求。',
            featureBox6Title: '24/7技术支持',
            featureBox6Desc: '专业技术团队全天候为您服务，及时解决各种问题，确保业务顺利运行。',
            // Pricing area
            pricingSectionTitle: 'Pricing Plans',
            pricingSectionSubtitle: '选择适合您需求的IP代理方案，灵活的流量选择，满足不同业务场景',
            beginnerPlan: 'BEGINNER',
            plan1GB: '1GB',
            plan10GB: '10GB',
            plan50GB: '50GB',
            plan100GB: '100GB',
            perMonth: '/月',
            // Pricing features
            unmeteredData: '无限数据使用',
            chooseCountries: '最多选择5个国家',
            staticIPUpdates: '每月20次静态IP更新',
            datacenterIP: '数据中心IP',
            staticResidentialIP: '静态住宅IP',
            rotatingResidentialIP: '动态住宅IP',
            mobileIP: '移动IP',
            tier1ISPs: '一级ISP',
            connectionLimit: '5个连接限制',
            socks5HTTPProxy: 'SOCKS5 & HTTP代理',
            countryIPUpdater: '国家/地区IP更新器',
            // Footer area
            footerTitle: 'IPIPBright',
            footerDesc: '提供全球动态IP代理服务，覆盖200+国家和地区，拥有超过1亿+IP资源，稳定可靠，满足各类业务需求。',
            followUs: '关注我们',
            quickLinks: '快速链接',
            productsServices: '产品服务',
            contactUs: '联系我们',
            privacy: '隐私政策',
            servicePolicy: '服务政策',
            footerContactDesc: '24/7技术支持，随时为您解答问题，提供专业的IP代理解决方案。'
          }
      }
    }
  },
  computed: {
    ...mapState({
      languageState: state => state.language
    }),
    // 获取当前语言的文本
    t() {
      const lang = this.languageState.currentLanguage;
      return this.i18n[lang] || this.i18n.en;
    }
  },
  methods: {
    ...mapMutations(['setLanguage']),
    // 设置语言
    setLanguage(lang) {
      this.changeLanguage(lang);
      this.activeDropdown = '';
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    handleMobileNavClick(path) {
      // 检查当前路由是否已经是目标路由，避免冗余导航警告
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
      this.isMobileMenuOpen = false
      this.activeDropdown = ''
    },
    toggleDropdown(event, dropdownName) {
      event.preventDefault()
      this.activeDropdown = this.activeDropdown === dropdownName ? '' : dropdownName
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    scrollToTop() {
      console.log('scrollToTop called');
      
      // 方法1：使用window.location.href直接跳转到页面顶部
      try {
        window.location.href = '#';
      } catch (e) {
        console.error('Method 1 failed:', e);
      }
      
      // 方法2：使用document.documentElement.scrollIntoView
      try {
        document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        console.error('Method 2 failed:', e);
      }
      
      // 方法3：使用document.body.scrollIntoView
      try {
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        console.error('Method 3 failed:', e);
      }
      
      // 方法4：直接设置scrollTop为0
      try {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch (e) {
        console.error('Method 4 failed:', e);
      }
      
      // 方法5：查找所有可能的滚动容器并设置scrollTop为0
      try {
        const scrollableElements = document.querySelectorAll('div, section, main, body, html');
        scrollableElements.forEach(el => {
          if (el.scrollTop > 0) {
            el.scrollTop = 0;
          }
        });
      } catch (e) {
        console.error('Method 5 failed:', e);
      }
    }
  },
  mounted() {
    // 使用requestAnimationFrame定期检查滚动位置
    const checkScrollPosition = () => {
      // 同时检查window.scrollY和document.documentElement.scrollTop，确保在不同浏览器中都能获取到正确的滚动位置
      const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
      const goTopBtn = document.getElementById('simple-go-top')
      if (goTopBtn) {
        if (scrollY > 300) {
          goTopBtn.style.opacity = '1'
          goTopBtn.style.visibility = 'visible'
        } else {
          goTopBtn.style.opacity = '0'
          goTopBtn.style.visibility = 'hidden'
        }
      }
      // 更新isSticky状态
      this.isSticky = scrollY > 50
      
      // 继续下一帧检查
      this.animationFrameId = requestAnimationFrame(checkScrollPosition)
    }
    
    // 启动requestAnimationFrame循环
    this.animationFrameId = requestAnimationFrame(checkScrollPosition)
    
    // 添加滚动动画效果 - Intersection Observer
    const observerOptions = {
      threshold: 0.2, // 元素20%进入视口时触发
      rootMargin: '0px 0px -100px 0px', // 增加底部margin，提前触发动画
      root: null
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 只添加一次animate类
          if (!entry.target.classList.contains('animate')) {
            // 为不同类型的元素设置不同的动画延迟
            const elementClass = entry.target.className;
            let delay = 0;
            
            // 为卡片元素添加交错延迟
            if (elementClass.includes('single_feature') || 
                elementClass.includes('single_service') || 
                elementClass.includes('country_ip_card') || 
                elementClass.includes('single_feature_box') || 
                elementClass.includes('single_pricing')) {
              // 获取元素在父容器中的索引
              const parent = entry.target.parentElement;
              if (parent) {
                const siblings = Array.from(parent.children);
                const index = siblings.indexOf(entry.target);
                delay = index * 100;
              }
            }
            
            // 使用requestAnimationFrame确保平滑动画
            requestAnimationFrame(() => {
              setTimeout(() => {
                entry.target.classList.add('animate');
              }, delay);
            });
            
            // 停止观察已动画元素，提高性能
            observer.unobserve(entry.target);
          }
        }
      });
    }, observerOptions);
    
    // 观察所有需要动画的元素
    const animatedElements = document.querySelectorAll(
      '.feature_area, .service_area, .country_ip_area, .pricing_area, ' +
      '.single_feature, .single_service, .country_ip_card, .single_feature_box, .single_pricing'
    );
    
    animatedElements.forEach((element) => {
      observer.observe(element);
    });
  },
  beforeDestroy() {
    // 取消requestAnimationFrame循环
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
    }
  }
}
</script>

<style scoped>
/* Desktop menu sticky styles */
#sticky-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #33342e !important;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
  width: auto;
}

/* Mobile menu styles */
.mobile-menu-area {
  background: #fff;
}

.mobile-menu-container {
  position: relative;
}

.mobile-menu-header {
  background: #32312d;
  min-height: 60px;
  padding: 4px 0 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999999;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Mobile menu container */
.mobile-menu-container {
  position: relative;
  z-index: 99999;
}

.mobile-menu-logo {
  flex: 1;
}

.mobile-menu-toggle {
  width: 40px;
  height: 40px;
  padding: 10px;
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 15px;
  /* background: rgba(255, 255, 255, 0.1); */
  border-radius: 4px;
}

.mobile-menu-toggle span {
  display: block;
  background: #fff;
  height: 3px;
  width: 24px;
  margin: 2px 0;
  transition: all 0.3s ease;
}

/* Mobile menu body should be fixed to viewport */
.mobile-menu-body {
  position: fixed !important;
  top: 60px;
  left: 0;
  right: 0;
  /* Make menu height smaller than full viewport */
  max-height: 70vh;
  margin-top: 0;
  z-index: 99998;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.95) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border: none !important;
}

/* Make menu list background transparent */
.mobile-menu-list {
  background: transparent !important;
}

/* Make menu items background transparent */
.mobile-menu-item {
  background: transparent !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.mobile-menu-item:first-child {
  border-top: none !important;
}

.mobile-menu-link-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-menu-link {
  display: block;
  padding: 1em 5%;
  color: #444;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  text-transform: uppercase;
  flex: 1;
}

.mobile-menu-link:hover {
  color: #1581c6;
}

.mobile-menu-expand {
  display: block;
  padding: 1em;
  color: #444;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  background: transparent;
  border: none;
  cursor: pointer;
}

.mobile-menu-expand:hover {
  color: #1581c6;
}

.mobile-sub-menu {
  padding: 0;
  margin: 0;
  list-style-type: none;
  background: #f8f8f8;
}

.mobile-sub-menu-item {
  border-top: 1px solid #eaeaea;
}

.mobile-sub-menu-link {
  display: block;
  padding: 0.8em 10%;
  color: #151948;
  font-size: 13px;
  font-weight: normal;
  text-decoration: none;
  text-transform: capitalize;
}

.mobile-sub-menu-link:hover {
  color: #1581c6;
}

@media (min-width: 1200px) {
  .container {
      max-width: 1400px !important;
  }
}

/* Hide browser scrollbars globally */
* {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

*::-webkit-scrollbar {
  display: none;
}

/* === Advanced CSS Transition Animations === */

/* Smooth scroll behavior */
html {
  scroll-behavior: smooth;
}

/* Section entrance animations - Smooth fade in from bottom */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Global transition for all elements - Smooth cubic-bezier */
* {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Navigation menu hover effects */
.cyber_menu ul.nav_scroll > li > a {
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.cyber_menu ul.nav_scroll > li > a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #1581c6, #1581c6);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(-50%);
}

.cyber_menu ul.nav_scroll > li > a:hover::after {
  width: 100%;
}

.cyber_menu ul.nav_scroll > li:hover > a {
  color: #1581c6 !important;
  transform: translateY(-3px);
  text-shadow: 0 2px 10px rgba(21, 129, 198, 0.3);
}

.cyber_menu ul.sub-menu {
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px) scale(0.95);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.cyber_menu ul.nav_scroll > li:hover > ul.sub-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}

/* Feature cards - Interactive hover effects */
.single_feature {
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border-radius: 12px;
}

.single_feature:hover {
  transform: translateY(-15px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(21, 129, 198, 0.2);
}

.single_feature_icon {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.single_feature:hover .single_feature_icon {
  transform: scale(1.2) rotate(10deg);
  color: #1581c6;
  filter: drop-shadow(0 5px 15px rgba(21, 129, 198, 0.4));
}

/* Service cards - Modern hover effects */
.single_service {
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border-radius: 12px;
}

.single_service:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
  background: linear-gradient(135deg, rgba(21, 129, 198, 0.02), rgba(21, 129, 198, 0.02));
  border-color: rgba(21, 129, 198, 0.3);
}

.single_service_icon {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.single_service:hover .single_service_icon {
  transform: scale(1.3) rotate(15deg);
  color: #1581c6;
  filter: drop-shadow(0 5px 15px rgba(21, 129, 198, 0.3));
}

/* Country IP cards - Elegant hover effects */
.country_ip_card {
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border-radius: 12px;
}

.country_ip_card:hover {
  transform: translateY(-12px) scale(1.03);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  border: 2px solid #1581c6;
}

.country_flag {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.country_ip_card:hover .country_flag {
  transform: scale(1.15);
  filter: brightness(1.1) drop-shadow(0 5px 15px rgba(0, 0, 0, 0.2));
}

/* Feature box area - Enhanced styles */
.feature_box_area {
  background: linear-gradient(135deg, #2d2c28 0%, #3a3935 100%);
  position: relative;
  overflow: hidden;
}

.feature_box_area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(21, 129, 198, 0.15) 0%, transparent 70%);
  z-index: 1;
  pointer-events: none;
}

.feature_box_area .container {
  position: relative;
  z-index: 2;
}

/* Feature boxes - Dynamic hover effects */
.single_feature_box {
  position: relative;
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border-radius: 20px;
  background: #3a3935;
  border: 1px solid rgba(21, 129, 198, 0.2);
  transform: translateY(0);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  /* Ensure all cards have the same size */
  height: 320px;
  min-height: 320px;
  max-height: 320px;
  display: flex;
  flex-direction: column;
}

.single_feature_box:hover {
  transform: translateY(-20px) scale(1.03);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  background: linear-gradient(135deg, #4a4945 0%, #3a3935 100%);
  border: 1px solid #1581c6;
}

.single_feature_box::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(21, 129, 198, 0.1) 0%, transparent 100%);
  opacity: 0;
  transition: all 0.5s ease;
  pointer-events: none;
  z-index: 1;
}

.single_feature_box:hover::after {
  opacity: 1;
}

.single_feature_box_icon {
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  background: #4a4945;
  z-index: 2;
  position: relative;
  border: 2px solid rgba(21, 129, 198, 0.3);
}

.single_feature_box:hover .single_feature_box_icon {
  transform: scale(1.3); /* Removed rotation, only scale */
  background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%);
  color: #fff;
  box-shadow: 0 10px 30px rgba(21, 129, 198, 0.6);
  border-color: #1581c6;
}

/* Enhanced animation for feature box area */
.feature_box_area.animate {
  animation: fadeInUp 0.8s ease forwards;
}

/* Improved stagger animation for feature boxes */
.single_feature_box.animate {
  animation: fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.single_feature_box:nth-child(1).animate {
  animation-delay: 0.05s;
}

.single_feature_box:nth-child(2).animate {
  animation-delay: 0.15s;
}

.single_feature_box:nth-child(3).animate {
  animation-delay: 0.25s;
}

.single_feature_box:nth-child(4).animate {
  animation-delay: 0.35s;
}

.single_feature_box:nth-child(5).animate {
  animation-delay: 0.45s;
}

.single_feature_box:nth-child(6).animate {
  animation-delay: 0.55s;
}

/* Section title animation */
.feature_box_area .section_title {
  opacity: 0;
  transform: translateY(-20px);
  transition: all 0.8s ease;
}

.feature_box_area.animate .section_title {
  opacity: 1;
  transform: translateY(0);
  animation: fadeInUp 0.8s ease forwards;
  animation-delay: 0.2s;
}

/* Pricing cards - Premium hover effects */
.single_pricing {
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border-radius: 16px;
}

.single_pricing:hover {
  transform: translateY(-20px) scale(1.02);
  box-shadow: 0 35px 70px rgba(0, 0, 0, 0.18);
}

.single_pricing_content_inner {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px;
}

.single_pricing:hover .single_pricing_content_inner {
  border: 2px solid #1581c6;
  background: linear-gradient(135deg, rgba(21, 129, 198, 0.03), rgba(21, 129, 198, 0.03));
}

/* Button effects - Enhanced styles */
/* Keep original button styles for slider buttons */
.slider_button_inner a {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  position: relative;
}

.slider_button_inner a:hover {
  transform: translateY(-4px);
  box-shadow: 0 15px 35px rgba(21, 129, 198, 0.8);
  /* Keep original color transition - text becomes white on purple background */
}

/* Custom styles for other buttons */
.order_now a,
.auth-buttons .auth-btn {
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  border-radius: 8px;
}

/* Use purple background for order buttons instead of white */
.order_now a::before,
.auth-buttons .auth-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(21, 129, 198, 0.8);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.6s ease, height 0.6s ease;
  z-index: -1;
}

.order_now a:hover::before,
.auth-buttons .auth-btn:hover::before {
  width: 300px;
  height: 300px;
}

.order_now a:hover,
.auth-buttons .auth-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 15px 35px rgba(21, 129, 198, 0.5);
  color: white !important;
  font-weight: bold;
}

/* Back to top button - Bounce animation */
#simple-go-top {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

#simple-go-top:hover {
  transform: translateY(-10px) scale(1.2);
  box-shadow: 0 20px 45px rgba(21, 129, 198, 0.8);
  background: linear-gradient(135deg, #1581c6, #1581c6);
  animation: none;
}

/* Image hover effects - Parallax */
.rotateme {
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.rotateme:hover {
  transform: rotate(15deg) scale(1.1);
  filter: brightness(1.1) drop-shadow(0 10px 25px rgba(0, 0, 0, 0.2));
}

/* Logo hover effect - Subtle animation */
.logo_img {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.logo_img:hover {
  transform: scale(1.1) rotate(5deg);
  filter: drop-shadow(0 5px 15px rgba(21, 129, 198, 0.3));
}

/* Social media icons - Spring animation */
.social_media a {
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: inline-block;
}

.social_media a:hover {
  transform: scale(1.5) rotate(10deg);
  color: #1581c6 !important;
  filter: drop-shadow(0 5px 15px rgba(21, 129, 198, 0.4));
}

/* Quick links - Smooth transition */
.quick-link-item {
  margin-bottom: 22px;
}

.quick-link-item h4 {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

.quick-link-item h4 i {
  margin-right: 8px;
  font-size: 12px;
  /* color: #7B4CF4; */
  flex-shrink: 0;
}

.quick-link-item h4 a {
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}

.quick-link-item h4 a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #1581c6;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.quick-link-item h4:hover a {
  color: #1581c6 !important;
  transform: translateX(8px);
  text-shadow: 0 2px 10px rgba(21, 129, 198, 0.2);
}

.quick-link-item h4:hover a::after {
  width: 100%;
}

/* Mobile menu - Smooth animations */
.mobile-menu-body {
  transform: translateY(0);
  opacity: 1;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(15px);
}

.mobile-menu-link {
  color: #fff !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.mobile-menu-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: #1581c6;
  transform: scaleY(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu-link:hover {
  color: #1581c6 !important;
  transform: translateX(10px);
  background: rgba(21, 129, 198, 0.1);
}

.mobile-menu-link:hover::before {
  transform: scaleY(1);
}

.mobile-menu-expand {
  color: #fff !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu-expand:hover {
  color: #1581c6 !important;
  transform: rotate(180deg) scale(1.2);
}

.mobile-sub-menu {
  background: rgba(255, 255, 255, 0.08) !important;
  max-height: 300px;
  /* padding: 15px 0; */
  animation: fadeInUp 0.4s ease forwards;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-sub-menu-link {
  color: #fff !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.mobile-sub-menu-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
  background: #1581c6;
  transform: scaleY(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-sub-menu-link:hover {
  color: #1581c6 !important;
  transform: translateX(15px);
  background: rgba(21, 129, 198, 0.15);
}

.mobile-sub-menu-link:hover::before {
  transform: scaleY(1);
}

/* Mobile menu toggle - Smooth animation */
.mobile-menu-toggle {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu-toggle:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: scale(1.1);
}

.mobile-menu-toggle:hover span {
  background: #1581c6;
}

</style>